var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',{staticClass:"mb-1"},[_vm._v("ตั้งค่านำเข้ามาตรฐาน")]),_c('shipping-rate-grid',{attrs:{"customer-id":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }